import { FIELD_ADDRESS_NAME } from './GoogleMapModal.constants'

export function getGoogleMapModalCenter(address, currentCity) {
  const isAddressCoordsExist = address?.lattitude && address?.longitude
  const isCurrentCityCoordsExist =
    currentCity?.lattitude && currentCity?.longitude

  return isAddressCoordsExist || isCurrentCityCoordsExist
    ? {
        lat: parseFloat(
          isAddressCoordsExist ? address?.lattitude : currentCity.lattitude
        ),
        lng: parseFloat(
          isAddressCoordsExist ? address?.longitude : currentCity.longitude
        ),
      }
    : null
}

export function getGoogleMapModalBuildingMarker(address) {
  if (address?.lattitude && address?.longitude) {
    return {
      name: 'buildingMarker',
      position: {
        lat: parseFloat(address?.lattitude),
        lng: parseFloat(address?.longitude),
      },
    }
  }

  return null
}

export function getInitialGoogleMapModalValues(value) {
  return { [FIELD_ADDRESS_NAME]: value }
}
